// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__pDP8F","left":"StickyBox_left__sNzFT","right":"StickyBox_right__6qbN9"};